import {
  GET_ENLIGHTEN_NOTICES_REQUEST,
  GET_ENLIGHTEN_NOTICES_SUCCESS,
  GET_ENLIGHTEN_NOTICES_FAILURE,
  ENLIGHTEN_NOTICES_DELETE_REQUEST,
  ENLIGHTEN_NOTICES_DELETE_SUCCESS,
  ENLIGHTEN_NOTICES_DELETE_FAILURE,
  GET_NOTICE_S3_URL_REQUEST,
  GET_USER_EMAILS_REQUEST,
  GET_USER_EMAILS_SUCCESS,
  GET_USER_EMAILS_FAILURE,
  DELETE_IMAGE_S3_URL_REQUEST,
  DELETE_IMAGE_S3_URL_SUCCESS,
  DELETE_IMAGE_S3_URL_FAILURE,
  GET_REVENUE_REPORT_FILE_REQUEST,
  GET_REVENUE_REPORT_FILE_SUCCESS,
  GET_REVENUE_REPORT_FILE_FAILURE,
  UPDATE_SERVICE_ROLES_REQUEST,
  UPDATE_SERVICE_ROLES_FAILURE,
  UPDATE_SERVICE_ROLES_SUCCESS,
  GET_SERVICE_ROLES_REQUEST,
  GET_SERVICE_ROLES_SUCCESS,
  GET_SERVICE_ROLES_FAILURE
} from './constants';

let initialState = {
  loading: false,
  message: '',
  messageType: '',
  enlightenNotices: {},
  emailIdList: [],
  revenueReportFile: '',
  availableServiceRoles: {},
  serviceAccessUpdateLoading: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_ENLIGHTEN_NOTICES_REQUEST:
      return { ...state, loading: true };
    case GET_ENLIGHTEN_NOTICES_SUCCESS:
      return {
        ...state,
        loading: false,
        enlightenNotices: action.enlightenNotices
      };
    case GET_ENLIGHTEN_NOTICES_FAILURE:
      return {
        ...state,
        loading: false,
        messageType: 'error',
        message: action.error
      };
    case ENLIGHTEN_NOTICES_DELETE_REQUEST:
      return { ...state, loading: true };
    case ENLIGHTEN_NOTICES_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: 'Success',
        messageType: 'success'
      };
    case ENLIGHTEN_NOTICES_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.error,
        messageType: 'error'
      };
    case GET_NOTICE_S3_URL_REQUEST: {
      return {
        ...state
      };
    }
    case GET_USER_EMAILS_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case GET_USER_EMAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        emailIdList: action.emailIdList
      };
    }
    case GET_USER_EMAILS_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }
    case DELETE_IMAGE_S3_URL_REQUEST:
      return { ...state, loading: true };
    case DELETE_IMAGE_S3_URL_SUCCESS:
      return {
        ...state,
        loading: false,
        message: 'Success',
        messageType: 'success'
      };
    case DELETE_IMAGE_S3_URL_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.error,
        messageType: 'error'
      };
    case GET_REVENUE_REPORT_FILE_REQUEST:
      return { ...state, loading: true };
    case GET_REVENUE_REPORT_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        revenueReportFile: action.revenueReportFile
      };
    case GET_REVENUE_REPORT_FILE_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.error,
        messageType: 'error'
      };
    case GET_SERVICE_ROLES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_SERVICE_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        availableServiceRoles: action.availableServiceRoles
      };
    case GET_SERVICE_ROLES_FAILURE:
      return {
        ...state,
        loading: false
      };
    case UPDATE_SERVICE_ROLES_REQUEST:
      return {
        ...state,
        serviceAccessUpdateLoading: true,
        message: '',
        messageType: ''
      };
    case UPDATE_SERVICE_ROLES_SUCCESS:
      return {
        ...state,
        serviceAccessUpdateLoading: false,
        message: 'Details updated successfully',
        messageType: 'success'
      };
    case UPDATE_SERVICE_ROLES_FAILURE:
      return {
        ...state,
        serviceAccessUpdateLoading: false,
        message: action.error,
        messageType: 'error'
      };
    default:
      return state;
  }
}

export default reducer;
